<script lang="ts" setup>
import AdministrationForm from "@/data-views/forms/administration/Form.vue";
definePage({
  meta: {
    action: "create",
    subject: "Administration",
  },
});
</script>

<template>
  <div>
    <AdministrationForm />
  </div>
</template>

<style lang="scss">
@use "@core/scss/template/libs/apex-chart.scss";
</style>
